var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPojokEdu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Curved/Activity"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Activity"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M6.9171 14.8539L9.9101 10.9649L13.3241 13.6449L16.2531 9.8649",
    stroke: "#939393",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6671 2.35001C20.7291 2.35001 21.5891 3.21001 21.5891 4.27201C21.5891 5.33301 20.7291 6.19401 19.6671 6.19401C18.6051 6.19401 17.7451 5.33301 17.7451 4.27201C17.7451 3.21001 18.6051 2.35001 19.6671 2.35001Z",
    stroke: "#939393",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 4",
    d: "M20.7555 9.26901C20.8885 10.164 20.9495 11.172 20.9495 12.303C20.9495 19.241 18.6375 21.553 11.6995 21.553C4.7625 21.553 2.4495 19.241 2.4495 12.303C2.4495 5.36601 4.7625 3.05301 11.6995 3.05301C12.8095 3.05301 13.8005 3.11201 14.6825 3.24001",
    stroke: "#939393",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPojokEdu);
export default __webpack_public_path__ + "static/media/pojokEdu.e71f730beb5c4797592ce714ed6e85c4.svg";
export { ForwardRef as ReactComponent };